module.exports = __webpack_public_path__ + "img/eco2.fc9d5df4.png";